import { t } from "./toNumber-DCDlkXWV.js";
var a = 1 / 0;
function n(r) {
  return r ? (r = t(r)) === a || r === -1 / 0 ? 17976931348623157e292 * (r < 0 ? -1 : 1) : r == r ? r : 0 : r === 0 ? r : 0;
}
export {
  n as t
};
//# sourceMappingURL=toFinite-dLr2ngf2.js.map
